import { render, staticRenderFns } from "./byline_field.vue?vue&type=template&id=b91563a0&lang=pug"
import script from "./byline_field.vue?vue&type=script&lang=js"
export * from "./byline_field.vue?vue&type=script&lang=js"
import style0 from "./byline_field.vue?vue&type=style&index=0&id=b91563a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports